import { render, staticRenderFns } from "./PreviewCourseContentsComponent.vue?vue&type=template&id=f41308be&"
import script from "./PreviewCourseContentsComponent.vue?vue&type=script&lang=js&"
export * from "./PreviewCourseContentsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports